<template lang="pug">
div.pad5
  app-divider(label="Dados do Título")
  el-row.pad5
    el-col(:span="12")
      p
        span.label Nome do beneficiário:
        span &nbsp {{filterNull(imovel.nomeBeneficiarioTitulo)}}
    el-col(:span="12" v-if="hasFieldsExtras")
      p
        span.label Nº do título:
        span &nbsp {{filterNull(imovel.numeroTitulo)}}
    el-col(:span="12" v-if="hasFieldsExtras")
      p
        span.label Área:
        span &nbsp {{formatterNumber(imovel.areaTitulo)}} hectare(s)
    el-col(:span="12" v-if="hasFieldsExtras")
      p
        span.label Data de expedição:
        span &nbsp {{formatDate(imovel.dataExpedicaoTitulo)}}
    el-col(:span="12" v-if="hasFieldsExtras")
      p
        span.label Município:
        span(v-if="imovel.municipioTitulo") &nbsp {{filterNull(imovel.municipioTitulo.nome)}}
        span(v-else) &nbsp -
    el-col.inputDiv(:span="12", v-if="hasFieldsExtras")
      p
        span.label {{labelsCadastro.imovel.lote}}
        span &nbsp {{filterNull(imovel.numeroLote)}}
</template>
<script>
import moment from 'moment'
import utils from '@/utils/utils'
import AppDivider from '../AppDivider'
const {labelsCadastro, inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider
  },
  data () {
    return {
      labelsCadastro,
      inputsExtraCadastro
    }
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    hasFieldsExtras: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    filterNull (atributo) {
      if (atributo != null && atributo.length === 0) {
        return '-'
      }
      return atributo !== null ? atributo : '-'
    },
    formatterNumber (value) {
      const options = {
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 4
      }

      return utils.format(value, options)
    },
    formatDate (data) {
      if (data) {
        return moment(new Date(data)).format('DD/MM/YYYY')
      }
      return '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoDadosTitulo.vue